module.exports = __webpack_public_path__ + "static/tech4covid19-logo-221869fea13f0b7160bda5529528a943.svg";